var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "Separator",
    style: { left: _vm.styleLeft },
    attrs: { draggable: "true" },
    on: {
      drag: function($event) {
        _vm.onDrag($event)
      },
      dragstart: function($event) {
        _vm.onDragStart($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }